<template>
  <div class="page__keyword a-page">
    <div style="background-color:white; padding:10px; border-radius: 4px; overflow: hidden">
      <div style="width: 100%">
        <span style="width: 40%; font-weight: 600; font-size: 13px">Link sản phẩm</span>
      </div>
      <div style="width: 100%">
        <el-input v-model="product_url" size="mini" style="width: 40%" placeholder="Nhập link sản phẩm..."
                  @keyup.enter.native="m__create_check_position"></el-input>
        &nbsp;
        &nbsp;
        <el-button size="mini" type="primary" icon="el-icon-plus" @click="m__create_check_position"
                   :loading="loading.create_check_position">Thêm sản phẩm
        </el-button>
      </div>

      <br>
      <br>
      <br>
      <el-row>
        <el-col :sm="14">
          <span style="width: 40%; font-weight: 600; font-size: 13px">Danh sách sản phẩm</span>
        </el-col>
        <el-col :sm="5" class="text-right" style="padding-right: 5px">
          <el-select size="mini" class="full-w" placeholder="Chọn shop" value="" v-model="selected_shop_id">
            <el-option :value="''" label="Tất cả shop"></el-option>
            <el-option v-for="shop in shop_list" :key="shop.shopid" :value="shop.shopid" :label="shop.name"></el-option>
          </el-select>
        </el-col>
        <el-col :sm="5" class="text-right" style="padding-left: 5px">
          <el-input size="mini" :placeholder="$t('input.placeholder')" v-model="search_keyword"></el-input>
        </el-col>
      </el-row>
      <el-table :data="check_position_filter_list" v-loading="loading.get_check_position">
        <el-table-column :label="$t('product.name')" prop="productName" show-tooltip-when-overflow></el-table-column>
        <el-table-column label="Định danh" prop="alias" show-tooltip-when-overflow></el-table-column>
        <el-table-column label="Link sản phẩm">
          <template slot-scope="scope">
            <a :href="`https://shopee.com/product-i.${scope.row.shopId}.${scope.row.productId}`" target="_blank">
              Xem sản phẩm</a>
          </template>
        </el-table-column>
        <el-table-column label="Link shop">
          <template slot-scope="scope">
            <a :href="`https://shopee.vn/shop/${scope.row.shopId}/search`" target="_blank">
              Xem shop</a>
          </template>
        </el-table-column>
        <el-table-column :label="$t('base.created_at')">
          <template slot-scope="scope">
            {{ scope.row.createdAt | moment('DD-MM-YYYY HH:mm') }}
          </template>
        </el-table-column>
        <el-table-column :label="$t('base.keyword')">
          <template slot-scope="scope">
            <a href="javascript:void(0)" @click="m__show_keywords_dialog(scope.row)">
              Xem từ khóa ({{ scope.row.keywords.length }})</a>
          </template>
        </el-table-column>
        <el-table-column :label="$t('base.action')" width="180px">
          <template slot-scope="scope">
            <el-button type="text" size="mini" :loading="loading.get_log"
                       @click="m__show_all_check_position_log(scope.row)"><strong class="text-success">Lịch sử vị
              trí</strong>
            </el-button>

            <el-button type="text" size="mini" @click="m__show_update_check_position(scope.row)">
              <strong class="text-warning">{{ $t('base.update') }}</strong>
            </el-button>

            <br>
            <el-button type="text" size="mini" @click="m__delete_check_position(scope.row)"><strong class="text-danger">{{
                $t('base.delete')
              }}</strong>
            </el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <el-dialog width="1000px" :close-on-click-modal="false" :visible.sync="show_dialog.keywords"
               custom-class="no-body">
      <div slot="title" style="padding:10px">
        <span style="width: 40%; font-weight: 600; font-size: 13px">Sản phẩm:</span><br>
        <a v-if="selected_check_position"
           :href="`https://shopee.com/product-i.${selected_check_position.shopId}.${selected_check_position.productId}`"
           target="_blank">
          {{ selected_check_position.productName }}
        </a>

        <br><br><br>

        <el-input v-model="keyword" size="mini" placeholder="Nhập từ khóa" style="width: 40%"
                  @keyup.enter.native="m__create_check_position_keyword"></el-input>
        &nbsp;&nbsp;
        <el-button size="mini" type="primary" icon="el-icon-plus" @click="m__create_check_position_keyword"
                   :loading="loading.create_check_position_keyword">
          Thêm từ khóa
        </el-button>
        &nbsp;&nbsp;
        <el-button size="mini" type="primary" icon="el-icon-upload" @click="m__choose_excel_file"
                   :loading="loading.create_check_position_keyword">
          {{ $t('base.import_from_excel') }}
        </el-button>
        &nbsp;&nbsp;
        <el-button style="float: right" size="mini" type="danger" icon="el-icon-delete"
                   @click="m__delete_all_check_position_keyword">
          Xóa tất cả từ khóa
        </el-button>
        <div style="clear: both"></div>
        <br>
        <br>
        <span style="width: 40%; font-weight: 600; font-size: 13px">{{ $t('keyword.list') }}</span>
        <el-table :data="keyword_list">
          <el-table-column :label="$t('base.keyword')" prop="keyword">
            <template slot-scope="scope">
              <a :href="`https://shopee.vn/search?keyword=${encodeURI(scope.row.keyword)}`"
                 target="_blank">{{ scope.row.keyword.normalize() }}</a>
            </template>
          </el-table-column>
          <el-table-column :label="$t('base.created_at')">
            <template slot-scope="scope">
              {{ scope.row.createdAt | moment('DD-MM-YYYY HH:mm') }}
            </template>
          </el-table-column>
          <el-table-column label="Ngày cập nhật">
            <template slot-scope="scope">
              {{ scope.row.updatedAt | moment('DD-MM-YYYY HH:mm') }}
            </template>
          </el-table-column>
          <el-table-column :label="$t('base.optional')">
            <template slot-scope="scope">
              <el-button size="mini" type="success" @click="m__show_check_position_log(scope.row)"
                         :loading="loading.get_log">Lịch sử vị trí
              </el-button>
            </template>
          </el-table-column>
          <el-table-column :label="$t('base.action')" width="250px">
            <template slot-scope="scope">
              <el-button :disabled="scope.row.status !== 'PENDING'" size="mini" type="primary"
                         :loading="loading.get_position"
                         :icon="scope.row.status === 'PENDING' ? 'el-icon-check' : 'el-icon-loading'"
                         @click="m__get_agency_position(scope.row)">
                <template v-if="scope.row.status === 'PENDING'">Xem vị trí</template>
                <template v-if="scope.row.status === 'RUNNING'">Đang lấy dữ liệu</template>
              </el-button>
              <el-button size="mini" type="danger" icon="el-icon-delete"
                         @click="m__delete_check_position_keyword(scope.row)"> {{ $t('base.delete') }}
              </el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </el-dialog>

    <el-dialog width="1000px" :close-on-click-modal="false" :visible.sync="show_dialog.get_log"
               custom-class="no-body">
      <div slot="title" style="padding:10px">
        <el-row>
          <el-col :sm="16">
            <span style="width: 40%; font-weight: 600; font-size: 13px">Từ khóa:</span>
            <a v-if="selected_check_position_keyword" target="_blank"
               :href="`https://shopee.vn/search?keyword=${encodeURI(selected_check_position_keyword.keyword)}`">{{
                selected_check_position_keyword.keyword
              }}</a>
            <br>
            <br>
            <br>
            <br>

            <span style="width: 40%; font-weight: 600; font-size: 13px">Lịch sử vị trí</span>
            &nbsp;&nbsp;&nbsp;&nbsp;
            <el-date-picker
              v-model="date_range"
              size="mini"
              type="daterange"
              format="dd-MM-yyyy"
              range-separator="-"
              :start-placeholder="$t('base.start_time')"
              :end-placeholder="$t('base.end_time')"
              @change="m__change_date_range">
            </el-date-picker>
          </el-col>

          <el-col :sm="8" class="text-right">
            <el-button size="mini" type="primary" icon="el-icon-download" @click="m__export_check_position_log">
              Tải file excel
            </el-button>
          </el-col>
        </el-row>

        <el-table :data="check_position_log">
          <el-table-column :label="$t('base.keyword')" prop="keyword">
          </el-table-column>
          <el-table-column label="Ngày cập nhật">
            <template slot-scope="scope">{{ scope.row.createdAt | moment('DD-MM-YYYY HH:mm') }}</template>
          </el-table-column>
          <el-table-column label="Vị trí hiển thị" prop="position">
          </el-table-column>
          <el-table-column label="Vị trí SEO" prop="seoPosition">
          </el-table-column>
        </el-table>
      </div>
    </el-dialog>

    <el-dialog width="1000px" :close-on-click-modal="false" :visible.sync="show_dialog.get_all_log"
               custom-class="no-body">
      <div slot="title" style="padding:10px">
        <el-row>
          <el-col :sm="16">
            <span style="width: 40%; font-weight: 600; font-size: 13px">Lịch sử vị trí</span>
            &nbsp;&nbsp;&nbsp;&nbsp;
            <el-date-picker
              v-model="date_range"
              size="mini"
              type="daterange"
              format="dd-MM-yyyy"
              range-separator="-"
              :start-placeholder="$t('base.start_time')"
              :end-placeholder="$t('base.end_time')"
              @change="m__change_date_range">
            </el-date-picker>

            <el-table :data="check_position_log">
              <el-table-column :label="$t('base.keyword')" prop="keyword">
              </el-table-column>
              <el-table-column label="Ngày cập nhật">
                <template slot-scope="scope">{{ scope.row.createdAt | moment('DD-MM-YYYY HH:mm') }}</template>
              </el-table-column>
              <el-table-column label="Vị trí hiển thị" prop="position">
              </el-table-column>
              <el-table-column label="Vị trí SEO" prop="seoPosition">
              </el-table-column>
            </el-table>
          </el-col>
          <el-col :sm="8" class="text-right">
            <el-button size="mini" type="primary" icon="el-icon-download" @click="m__export_check_position_log">
              Tải file excel
            </el-button>
          </el-col>
        </el-row>
      </div>
    </el-dialog>

    <el-dialog width="400px" :close-on-click-modal="false" :visible.sync="show_dialog.update_check_position"
               custom-class="no-body">
      <div slot="title" style="padding:10px">
        <p class="text-title">Định danh</p>
        <el-input size="mini" placeholder="Nhập định danh" v-model="alias"></el-input>

        <br>
        <br>
        <div class="text-right">
          <el-button size="mini" type="primary" icon="el-icon-check" :loading="loading.update_check_position"
                     @click="m__update_check_position">
            {{ $t('base.update') }}
          </el-button>
        </div>
      </div>
    </el-dialog>

    <input accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" type="file"
           @change="m__import_excel_file" id="input_control_check_position" style="display: none;">
  </div>
</template>

<script>
//import dayjs from 'dayjs'
import readXlsxFile from 'read-excel-file'
import {uniqBy as _uniqBy} from 'lodash'

export default {
  name: 'page__agency_check_position',

  data() {
    return {
      check_position_list: [],
      selected_check_position: null,
      selected_check_position_keyword: null,
      product_url: '',
      loading: {
        get_check_position: false,
        create_check_position: false,
        update_check_position: false,
        create_check_position_keyword: false,
        get_position: false,
        get_log: false
      },
      show_dialog: {
        update_check_position: false,
        keywords: false,
        get_log: false,
        get_all_log: false
      },
      keyword: '',
      keyword_list: [],
      check_position_log: [],
      date_range: '',
      search_keyword: '',
      alias: '',
      shop_list: [],
      selected_shop_id: ''
    }
  },

  async beforeMount() {
    await this.m__get_check_position_list()
  },

  computed: {
    check_position_filter_list() {
      let result = this.check_position_list

      if (this.selected_shop_id) {
        result = result.filter(i => i.shopId === this.selected_shop_id)
      }

      const words = this.remove_unicode(this.search_keyword)
      return result.filter(item => this.remove_unicode(JSON.stringify(item)).includes(words))
    }
  },

  methods: {
    m__show_update_check_position(data) {
      this.alias = data.alias || ''
      this.selected_check_position = data
      this.show_dialog.update_check_position = true
    },

    async m__update_check_position() {
      if (!this.alias) {
        this.ntf_w('Vui lòng nhập định danh')
        return
      }

      try {
        this.loading.update_check_position = true
        await this.$http.put(this.API.URL_API_SRV_1 + '/check_position', {
          mipeeUserId: this.$store.state.userInfo.username,
          checkPositionId: this.selected_check_position.id,
          alias: this.alias
        }, this.cf())
        await this.m__get_check_position_list()
        this.ntf_s(this.$t('base.update_success'))
        this.show_dialog.update_check_position = false
      } catch (e) {
        this.ntf_w(this.$t('base.has_an_occurred'))
      } finally {
        this.loading.update_check_position = false
      }
    },

    m__show_keywords_dialog(data) {
      this.selected_check_position = data
      this.keyword_list = data.keywords
      this.show_dialog.keywords = true
    },

    async m__get_check_position_list() {
      this.loading.get_check_position = true
      try {
        const resp = await this.$http.get(this.API.URL_API_SRV_1 + '/check_position',
          {params: {mipeeUserId: this.$store.state.userInfo.username}, ...this.cf()})

        const shop_id_uniq = _uniqBy(resp.data, 'shopId')
        const shop_ids = shop_id_uniq.map(i => i.shopId)
        for (const shop_id of shop_ids) {
          const shop_resp = await this.request_to_shopee({
            url: `https://shopee.vn/api/v2/shop/get?shopid=${shop_id}`
          })
          this.shop_list.push({
            shopid: shop_resp.body.data.data.shopid,
            name: shop_resp.body.data.data.account.username
          })
        }

        this.check_position_list = resp.data
      } catch (e) {
        console.error(e)
      } finally {
        this.loading.get_check_position = false
      }
    },

    async m__create_check_position() {
      const expression = /[-a-zA-Z0-9@:%._+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_+.~#?&/=]*)?/ig
      const regex = new RegExp(expression)
      if (!this.product_url.match(regex)) {
        this.ntf_w('Đường dẫn của sản phẩm không hợp lệ!')
        return
      }

      const split = this.product_url.split('.')
      if (!split || split.length < 2) {
        this.ntf_w('Đường dẫn của sản phẩm không hợp lệ!')
        return
      }

      const shop_id = split[split.length - 2]
      const product_id = split[split.length - 1]
      if (!shop_id || Number.isNaN(+shop_id) || !product_id || Number.isNaN(+product_id)) {
        this.ntf_w('Đường dẫn của sản phẩm không hợp lệ!')
        return
      }

      this.loading.create_check_position = true
      try {
        let product_resp = await this.request_to_shopee({
          url: `https://shopee.vn/api/v2/item/get?itemid=${product_id}&shopid=${shop_id}`
        })

        if (product_resp && product_resp.body && product_resp.body.data && product_resp.body.data.item) {
          const product = product_resp.body.data.item

          await this.$http.post(this.API.URL_API_SRV_1 + '/check_position', {
            mipeeUserId: this.$store.state.userInfo.username,
            productLink: this.product_url,
            productName: product.name,
            productId: product.itemid,
            shopId: product.shopid
          }, this.cf())
          await this.m__get_check_position_list()
          this.product_url = ''
          this.ntf_s('Thêm sản phẩm thành công')
        } else {
          this.ntf_w('Không tìm thấy sản phẩm!')
        }
      } catch (e) {
      } finally {
        this.loading.create_check_position = false
      }
    },

    async m__delete_check_position(data) {
      try {
        await this.$confirm(`Bạn có chắc chắn muốn xóa sản phẩm này không?`, this.$t('base.attention'), {
          confirmButtonText: this.$t('base.confirm'),
          cancelButtonText: this.$t('base.cancel'),
          type: 'warning'
        })
        await this.$http.delete(this.API.URL_API_SRV_1 + '/check_position',
          {
            params: {
              mipeeUserId: this.$store.state.userInfo.username,
              checkPositionId: data.id
            }, ...this.cf()
          })
        await this.m__get_check_position_list()
        this.ntf_s(this.$t('base.delete_success'))
      } catch (e) {
      }
    },

    async m__create_check_position_keyword() {
      if (!this.keyword) {
        this.ntf_w('Vui lòng nhập từ khóa')
        return
      }

      if (this.selected_check_position) {
        try {
          this.loading.create_check_position_keyword = true
          await this.$http.post(this.API.URL_API_SRV_1 + '/check_position/keyword', {
            mipeeUserId: this.$store.state.userInfo.username,
            checkPositionId: this.selected_check_position.id,
            maxPosition: 2000,
            keywords: [this.keyword]
          }, this.cf())

          await this.m__get_check_position_list()
          this.keyword_list = this.check_position_list.find(i => i.id === this.selected_check_position.id).keywords
          this.keyword = ''

          this.ntf_s('Thêm từ khóa thành công')
        } catch (e) {
          console.log(e)
        } finally {
          this.loading.create_check_position_keyword = false
        }
      }
    },

    async m__delete_check_position_keyword(data) {
      try {
        await this.$confirm(`Bạn có chắc chắn muốn xóa từ khóa này không?`, this.$t('base.attention'), {
          confirmButtonText: this.$t('base.confirm'),
          cancelButtonText: this.$t('base.cancel'),
          type: 'warning'
        })
        await this.$http.delete(this.API.URL_API_SRV_1 + '/check_position/keyword',
          {
            params: {
              mipeeUserId: this.$store.state.userInfo.username,
              checkPositionKeywordId: data.id
            }, ...this.cf()
          })
        await this.m__get_check_position_list()
        this.keyword_list = this.check_position_list.find(i => i.id === this.selected_check_position.id).keywords
        this.ntf_s('Xóa từ khóa thành công')
      } catch (e) {
      }
    },

    async m__delete_all_check_position_keyword() {
      try {
        await this.$confirm(`Bạn có chắc chắn muốn xóa tất cả từ khóa không?`, this.$t('base.attention'), {
          confirmButtonText: this.$t('base.confirm'),
          cancelButtonText: this.$t('base.cancel'),
          type: 'warning'
        })
        await this.$http.delete(this.API.URL_API_SRV_1 + '/check_position/keyword/all', {
          params: {
            mipeeUserId: this.$store.state.userInfo.username,
            checkPositionId: this.selected_check_position.id
          },
          ...this.cf()
        })
        await this.m__get_check_position_list()
        this.keyword_list = this.check_position_list.find(i => i.id === this.selected_check_position.id).keywords
        this.ntf_s('Xóa từ khóa thành công')
      } catch (e) {
      }
    },

    m__choose_excel_file() {
      this.$el.querySelector(`#input_control_check_position`).click()
    },

    async m__import_excel_file(e) {
      try {

        const file_store = e.target.files || e.dataTransfer.files
        if (file_store.length === 0) {
          return
        }

        this.loading.create_check_position_keyword = true

        const keywords = []
        const raw = await readXlsxFile(file_store[0])
        for (const row of raw) {
          if (row && row[0]) keywords.push(row[0])
        }

        await this.$http.post(this.API.URL_API_SRV_1 + '/check_position/keyword', {
          mipeeUserId: this.$store.state.userInfo.username,
          checkPositionId: this.selected_check_position.id,
          maxPosition: 5000,
          keywords: keywords
        }, this.cf())

        await this.m__get_check_position_list()
        this.keyword_list = this.check_position_list.find(i => i.id === this.selected_check_position.id).keywords
        this.ntf_s('Thêm từ khóa thành công')
      } catch (e) {
        console.log(e)
        this.ntf_w(this.$t('base.error_reading_file'))
      } finally {
        this.loading.create_check_position_keyword = false
      }
    },

    async m__get_agency_position(data) {
      this.loading.get_position = true
      await this.$http.get(this.API.URL_API_SRV_2 + '/mipee/agency/get-agency-position', {
        ...this.cf(),
        params: {checkPositionKeywordId: data.id}
      })
      this.ntf_s('Lấy vị trí SEO thành công')
      this.loading.get_position = false
    },

    async m__show_check_position_log(data) {
      this.date_range = [
        this.dayjs().subtract(7, 'd').toDate(),
        this.dayjs().toDate()
      ]
      this.loading.get_log = true
      this.show_dialog.get_log = true
      this.selected_check_position_keyword = data
      await this.m__get_check_position_log()
      this.loading.get_log = false
    },

    async m__show_all_check_position_log(data) {
      this.date_range = [
        this.dayjs().subtract(7, 'd').toDate(),
        this.dayjs().toDate()
      ]
      this.loading.get_log = true
      this.selected_check_position = data
      this.show_dialog.get_all_log = true
      await this.m__get_check_position_log()
      this.loading.get_log = false
    },

    async m__change_date_range() {
      await this.m__get_check_position_log()
    },

    async m__get_check_position_log() {
      const startDate = this.dayjs(this.date_range[0]).format('YYYY-MM-DD')
      const endDate = this.dayjs(this.date_range[1]).format('YYYY-MM-DD')

      let checkPositionKeywordIds
      if (this.show_dialog.get_log) {
        checkPositionKeywordIds = this.selected_check_position_keyword.id
      }
      if (this.show_dialog.get_all_log) {
        console.log(this.selected_check_position.keywords)
        checkPositionKeywordIds = this.selected_check_position.keywords.map(i => i.id).join(',')
      }
      const resp = await this.$http.get(this.API.URL_API_SRV_1 + '/check_position/keyword/log/all', {
        params: {
          checkPositionKeywordIds: checkPositionKeywordIds,
          startDate,
          endDate
        },
        ...this.cf()
      })
      for (const item of resp.data) {
        const check_position_keyword = this.selected_check_position.keywords.find(i => i.id === item.checkPositionKeywordId)
        if (check_position_keyword) {
          item.keyword = check_position_keyword.keyword
        }
      }
      this.check_position_log = resp.data
    },

    async m__export_check_position_log() {
      const response = await this.$http.post(this.API.URL_API_SRV_2 + '/mipee/agency/export_check_position_log', {
        check_position_log: this.check_position_log
      }, {
        ...this.cf(),
        responseType: 'blob'
      })

      const url = window.URL.createObjectURL(new Blob([response.body]))
      const link = document.createElement('a')
      link.href = url
      link.setAttribute('download', `agency_export.xlsx`)
      document.body.appendChild(link)
      link.click()
    }
  }
}
</script>

<style></style>



// WEBPACK FOOTER //
// src/temp/agency/check_position.vue